/* eslint-disable max-statements */
import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";

export const INITIAL_STATE = {
    pageLoading: false,
    loaderTitle: ""
};

export const setPageLoading = (state = INITIAL_STATE, { pageLoading, loaderTitle }) => {
    return { ...state, pageLoading, loaderTitle };
};

export const HANDLERS = {
    [Types.SET_PAGE_LOADING]: setPageLoading
};

export default createReducer(INITIAL_STATE, HANDLERS);
